export default "__VITE_ASSET__Bv8NvjjX__"